<section
  class="animate-in fade-in slide-in-from-bottom-2 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-xl duration-500">
  <div class="flex items-center justify-between border-b border-gray-200 pb-3">
    <div class="flex items-center gap-2">
      <h2 class="text-[16px] font-bold text-neutral-800">
        {{ isArabic() ? "المعلومات الأساسية" : "Basic Information" }}
      </h2>
    </div>
    <!-- <span [ngClass]="getStatusClass(bundle().status)" class="rounded-full px-3 py-1 text-[12px] font-bold">
      {{ isArabic() ? bundle().status.titleAr : bundle().status.titleEn }}
    </span> -->
  </div>

  <div class="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-3">
    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="textTabsColor font-bold uppercase">
        {{ isArabic() ? "اسم الباقة" : "Bundle Name" }}
      </span>
      <span class="valueColor">
        {{
          isArabic()
            ? bundle().titleAr || bundle().titleEn || "غير متوفر"
            : bundle().titleEn || bundle().titleAr || "Not Provided"
        }}
      </span>
    </div>

    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="textTabsColor font-bold uppercase" i18n="@@status">status</span>
      <span class="valueColor">
        <span
          [ngClass]="getStatusClass(bundle().status)"
          class="inline-flex min-w-[75px] items-center justify-center rounded-full px-2 py-1 text-[10px] font-bold">
          {{ isArabic() ? bundle().status.titleAr || "غير متوفر" : bundle().status.titleEn || "Not Provided" }}
        </span>
      </span>
    </div>
    <div class="flex flex-col gap-1 rounded-lg p-2.5"></div>

    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="textTabsColor font-bold uppercase">{{ isArabic() ? "تاريخ البداية" : "Start Date" }}</span>
      <span class="valueColor">{{ (bundle().startDate | dateTime) || "—" }}</span>
    </div>

    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="textTabsColor font-bold uppercase">{{ isArabic() ? "تاريخ النهاية" : "End Date" }}</span>
      <span class="valueColor">{{ (bundle().endDate | dateTime) || "—" }}</span>
    </div>

    <div class="col-span-1 flex flex-col gap-1.5 border-t border-gray-50 pt-3 md:col-span-3">
      <span class="textTabsColor font-bold">{{ isArabic() ? "وصف الباقة" : "Bundle Description" }}</span>
      <p class="valueColor max-w-3xl text-[13px] leading-[1.5] font-medium">
        {{
          isArabic()
            ? bundle().descriptionAr || bundle().descriptionEn || "غير محدد"
            : bundle().descriptionEn || bundle().descriptionAr || "Not Set"
        }}
      </p>
    </div>
  </div>
</section>

<section
  class="animate-in fade-in slide-in-from-bottom-2 mt-6 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-xl duration-500">
  <div class="flex flex-col gap-1.5 border-b-2 border-gray-300 pb-3">
    <h2 class="title text-[18px] font-bold">{{ isArabic() ? "تفاصيل الأسعار" : "Pricing Information" }}</h2>
  </div>

  <div class="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-3">
    @if (bundle().discountType) {
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="textTabsColor font-bold uppercase">{{ isArabic() ? "نوع الخصم" : "Discount Type" }}</span>
        <span class="valueColor">
          {{
            bundle().discountType === "PERCENTAGE"
              ? isArabic()
                ? "نسبة مئوية"
                : "Percentage"
              : isArabic()
                ? "مبلغ ثابت"
                : "Fixed Amount"
          }}
        </span>
      </div>
    }

    @if (bundle().discountValue) {
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="textTabsColor font-bold uppercase">{{ isArabic() ? "قيمة الخصم" : "Discount Value" }}</span>
        <span class="valueColor text-lg font-bold">
          {{
            bundle().discountType === "PERCENTAGE"
              ? bundle().discountValue + "%"
              : bundle().discountValue + " " + (isArabic() ? "ج.م" : "EGP")
          }}
        </span>
      </div>
    }

    <div class="flex flex-col gap-1 rounded-lg p-2.5"></div>

    @if (bundle().pharmacyPriceBeforeDiscount) {
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="textTabsColor font-bold uppercase">
          {{ isArabic() ? "سعر الصيدلية قبل الخصم" : "Pharmacy Price (Before Discount)" }}
        </span>
        <span class="valueColor text-lg font-bold">
          {{ bundle().pharmacyPriceBeforeDiscount }} {{ isArabic() ? "ج.م" : "EGP" }}
        </span>
      </div>
    }

    @if (bundle().pharmacyPriceAfterDiscount) {
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="textTabsColor font-bold uppercase">
          {{ isArabic() ? "سعر الصيدلية بعد الخصم" : "Pharmacy Price (After Discount)" }}
        </span>
        <span class="valueColor text-lg font-bold">
          {{ bundle().pharmacyPriceAfterDiscount }} {{ isArabic() ? "ج.م" : "EGP" }}
        </span>
      </div>
    }
  </div>
</section>

<section
  class="animate-in fade-in slide-in-from-bottom-2 mt-6 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-xl duration-500">
  <div class="flex flex-col gap-1.5 border-b-2 border-gray-300 pb-3">
    <h2 class="title text-[18px] font-bold">{{ isArabic() ? "تفاصيل الفحص  " : "Audit Information" }}</h2>
  </div>

  <div class="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-3">
    <div class="flex flex-col gap-1 rounded-lg p-2.5">
      <span class="textTabsColor font-bold uppercase">{{ isArabic() ? "أنشئ بواسطة" : "Created By" }}</span>
      <span class="valueColor">{{ bundle().createdBy.fullName || "—" }}</span>
      <span class="valueColor">{{ bundle().createdOn | date }}</span>
    </div>

    @if (bundle().lastModifiedBy) {
      <div class="flex flex-col gap-1 rounded-lg p-2.5">
        <span class="textTabsColor font-bold uppercase">
          {{ isArabic() ? "آخر تعديل بواسطة" : "Last Modified By" }}
        </span>
        <span class="valueColor">{{ bundle().lastModifiedBy.fullName }}</span>
        <span class="valueColor">{{ bundle().lastModifiedOn | date }}</span>
      </div>
    }
  </div>
</section>
